document.querySelectorAll(".downloads__more").forEach((btn) => {
  btn.addEventListener("click", () => {
    const table = btn.closest(".downloads");
    table.querySelectorAll(".downloads__row.hide").forEach((row) => {
      row.classList.remove("hide");
    });
    btn.hidden = true;
  });
});
